<template>
  <section v-if="visible && safeTasks.length > 0" class="paper-download-list" :class="{ collapsed }">
    <header>
      <strong>{{ displayTitle }}</strong>
      <span>{{ summary }}</span>
      <button type="button" @click="$emit('toggle-collapse')">{{ collapsed ? ui.expand : ui.collapse }}</button>
      <button type="button" @click="$emit('close')">{{ ui.close }}</button>
    </header>
    <div v-if="!collapsed" class="paper-download-task-list">
      <div v-for="task in safeTasks" :key="task.id" class="paper-download-task">
        <div class="paper-download-task-head">
          <strong :title="task.fileName">{{ task.fileName }}</strong>
          <span>{{ task.progress }}%</span>
        </div>
        <div class="paper-download-task-foot">
          <span class="paper-download-task-status">{{ task.statusText }}</span>
          <button v-if="task.state == 'done' && canOpenTask(task)" type="button" @click="$emit('open-task', task)">{{ ui.open }}</button>
          <button v-if="task.state == 'error'" type="button" @click="$emit('retry-task', task)">{{ ui.retry }}</button>
          <button type="button" @click="$emit('remove-task', task)">{{ ui.clear }}</button>
        </div>
        <div class="paper-download-progress">
          <i :style="{ width: task.progress + '%' }"></i>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getAppUiText } from '@/utils/language/common'

export default {
  name: 'PaperDownloadList',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    tasks: {
      type: Array,
      default() {
        return []
      }
    },
    summary: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: 'us'
    },
    title: {
      type: String,
      default: ''
    },
    canOpenTask: {
      type: Function,
      default() {
        return false
      }
    }
  },
  computed: {
    ui() {
      return getAppUiText(this.language)
    },
    displayTitle() {
      return this.title || this.ui.downloadList
    },
    safeTasks() {
      return Array.isArray(this.tasks) ? this.tasks : []
    }
  }
}
</script>

<style scoped>
.paper-download-list {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 460px;
  max-width: calc(100% - 48px);
  max-height: 30vh;
  background: #fff;
  border: 1px solid #d8d8d8;
  box-shadow: 0 8px 22px rgba(0, 0, 0, .12);
  z-index: 4500;
  display: flex;
  flex-direction: column;
}

.paper-download-list.collapsed {
  max-height: 56px;
}

.paper-download-list > header {
  height: 56px;
  padding: 0 18px;
  border-bottom: 1px solid #e5e5e2;
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.paper-download-list.collapsed > header {
  border-bottom: 0;
}

.paper-download-list > header strong {
  color: #111;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  white-space: nowrap;
}

.paper-download-list > header span {
  min-width: 0;
  color: #666;
  font-size: 14px;
  line-height: 20px;
  flex: 1;
}

.paper-download-list > header button {
  border: 0;
  background: transparent;
  color: #1f3a2d;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
}

.paper-download-task-list {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 10px 16px 14px;
}

.paper-download-task {
  padding: 12px 4px 14px;
  border-bottom: 1px solid #eeeeeb;
}

.paper-download-task:last-child {
  border-bottom: 0;
}

.paper-download-task-head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.paper-download-task-head strong {
  min-width: 0;
  color: #111;
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;
}

.paper-download-task-head span,
.paper-download-task-status {
  color: #666;
  font-size: 14px;
  line-height: 20px;
}

.paper-download-task-foot {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 4px;
}

.paper-download-task-status {
  min-width: 0;
  flex: 1;
}

.paper-download-task-foot button {
  border: 0;
  background: transparent;
  color: #1f3a2d;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
}

.paper-download-progress {
  height: 6px;
  margin-top: 10px;
  background: #e4e7e2;
  overflow: hidden;
}

.paper-download-progress i {
  display: block;
  height: 100%;
  background: #1f3a2d;
  transition: width .18s ease;
}
</style>
